<template>
    <div class="lang">
        <div class="reservation-lang">
            <div class="info">
                <h3 class="bullet01">患者信息</h3>
                <div class="input-form mt20">
                    <ul class="input-form__list">
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span> 患者ID <br>
                                    (Revisiting Patient Only)</div>
                                <div class="cont"><input type="text" class="input" placeholder="Patient ID" v-model="params.ptNo" ref="ptNo"></div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span> 姓名</div>
                                <div class="cont item2">
                                    <input type="text" class="input" placeholder="名字 姓名" v-model="params.firstName" ref="firstName">
                                    <input type="text" class="input" placeholder="姓氏 姓名" v-model="params.lastName" ref="lastName">
                                </div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span> 性别</div>
                                <div class="cont">
                                    <div class="radio-wrap">
                                        <label  >
                                            <input type="radio" name="gender1" id="gender1" value="M" v-model="params.gender">
                                            <span class="radio-btn"></span>
                                            <p>男性</p>
                                        </label>
                                        <label  >
                                            <input type="radio" name="gender2" id="gender2" value="F" v-model="params.gender">
                                            <span class="radio-btn"></span>
                                            <p>女性</p><input type="text" disabled="">
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </li>

                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span>出生日期</div>
                                <div class="cont"><input type="text" class="input" placeholder="ex)19800320" v-model="params.birth" ref="birth" maxlength="8"></div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span>国籍</div>
                                <div class="cont"><input type="text" class="input" v-model="params.national" ref="national"></div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span> 语言</div>
                                <div class="cont"><input type="text" class="input" v-model="params.language" ref="language"></div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span> 居住国</div>
                                <div class="cont">
                                    <div class="radio-wrap">
                                        <label  >
                                            <input type="radio" name="country1" id="country1" value="K" v-model="params.countryGubun">
                                            <span class="radio-btn"></span>
                                            <p>韩国</p>
                                        </label>
                                        <label  >
                                            <input type="radio" name="country2" id="country2" value="O" v-model="params.countryGubun">
                                            <span class="radio-btn"></span>
                                            <p>其他</p><input type="text" disabled="">
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit">母国地址</div>
                                <div class="cont"><input type="text" class="input" v-model="params.addressHome"></div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span>韩国地址</div>
                                <div class="cont"><input type="text" class="input" v-model="params.address" ref="address"></div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span>电话号码</div>
                                <div class="cont">
                                    <input type="text" class="input" v-model="params.hpNo" ref="hpNo">
                                    <!-- <p>- Please leave korean phone number or email address.</p> -->
                                </div>

                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit">紧急联系人</div>
                                <div class="items">
                                    <div class="cont">
                                        <div class="tit2">姓名</div><input type="text" class="input" v-model="params.emergencyNm">
                                    </div>
                                    <div class="cont">
                                        <div class="tit2">与病人的关系</div><input type="text" class="input" v-model="params.emergencyPatRelation">
                                    </div>
                                    <div class="cont">
                                        <div class="tit2">电话号码</div><input type="text" class="input" v-model="params.emergencyHpNo">
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span>保险信息</div>
                                <div class="cont"><input type="text" class="input" v-model="params.insuranceInfo" ref="insuranceInfo"></div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="info">
                <h3 class="bullet01">预约 详细信息</h3>
                <div class="input-form mt20">
                    <ul class="input-form__list">
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span>症状 <br>
                                    (预约就诊原因)</div>
                                <div class="cont">
                                    <textarea name="" id="" class="textarea" v-model="params.symptoms" ref="symptoms"></textarea>
                                </div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span> 所需医疗服务</div>
                                <div class="cont">
                                    <textarea name="" id="" class="textarea" v-model="params.mediServiceReq" ref="mediServiceReq"></textarea>
                                </div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span> 首选日期和时间</div>
                                <div class="items">
                                    <div class="cont">
                                        <div class="tit2">第1</div>
                                        <div class="table-search type2">
                                            <div class="dp__input_wrap">
                                                <VueDatePicker v-model="preDate1" locale="en" :format="formatDate" :enable-time-picker="false" week-start="0" position="left" placeholder="ex) 2025-01-01" auto-apply/>
                                            </div>
                                            <div class="row">
                                                <div class="select">
                                                    <a href="javascript:;" class="select--btn" :class="{ active: select01 }" @click.prevent="activeselect01">{{params.rsvhour1 ? params.rsvhour1 : '选择小时'}}</a>
                                                    <slide-up-down :active="select01" class="select-option">
                                                        <a href="javascript:;" class="select-option--btn" v-for="i in 23" :key="i" @click="[params.rsvhour1 = i, activeselect01()]">{{i}}</a>
                                                    </slide-up-down>
                                                </div>
                                                :
                                                <div class="select">
                                                    <a href="javascript:;" class="select--btn" :class="{ active: select02 }" @click.prevent="activeselect02">{{params.rsvmin1 ? params.rsvmin1 : '选择分钟'}}</a>
                                                    <slide-up-down :active="select02" class="select-option">
                                                        <a href="javascript:;" class="select-option--btn" v-for="i in 59" :key="i" @click="[params.rsvmin1 = i, activeselect02()]">{{i}}</a>
                                                    </slide-up-down>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="cont">
                                        <div class="tit2">第2</div>
                                        <div class="table-search type2">
                                            <div class="dp__input_wrap">
                                                <VueDatePicker v-model="preDate2" locale="en" :format="formatDate" :enable-time-picker="false" week-start="0" position="left" placeholder="ex) 2025-01-01" auto-apply/>
                                            </div>
                                            <div class="row">
                                                <div class="select">
                                                    <a href="javascript:;" class="select--btn" :class="{ active: select03 }" @click.prevent="activeselect03">{{params.rsvhour2 ? params.rsvhour2 : '选择小时'}}</a>
                                                    <slide-up-down :active="select03" class="select-option">
                                                        <a href="javascript:;" class="select-option--btn" v-for="i in 23" :key="i" @click="[params.rsvhour2 = i, activeselect03()]">{{i}}</a>
                                                    </slide-up-down>
                                                </div>
                                                :
                                                <div class="select">
                                                    <a href="javascript:;" class="select--btn" :class="{ active: select04 }" @click.prevent="activeselect04">{{params.rsvmin2 ? params.rsvmin2 : '选择分钟'}}</a>
                                                    <slide-up-down :active="select04" class="select-option">
                                                        <a href="javascript:;" class="select-option--btn" v-for="i in 59" :key="i" @click="[params.rsvmin2 = i, activeselect04()]">{{i}}</a>
                                                    </slide-up-down>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit">附加医疗报告</div>
                                <div class="cont">
                                    <input type="text" class="input" style="pointer-events: none;" v-model="params.uploadFileName">
                                    <label class="file">
                                        <input type="file" accept=".txt, .pdf, .hwp, .docx, .jpg, .png, .gif" @change="onFileChange($event.target, 'uploadFile')">
                                        <div class="main-button c-gray">附加文件</div>
                                    </label>
                                </div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit">附加链接</div>
                                <div class="cont">
                                    <input type="text" class="input" v-model="params.attachLink">
                                </div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit">附加图像</div>
                                <div class="cont">
                                    <input type="text" class="input" style="pointer-events: none;" v-model="params.uploadImgName">
                                    <label class="file">
                                        <input type="file" accept=".jpg, .png, .gif" @change="onFileChange($event.target, 'uploadImg')">
                                        <div class="main-button c-gray">附加文件</div>
                                    </label>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="botton-wrap">
                    <a href="javascript:;" class="sub-button c-gray" @click="cancelReservation">取消</a>
                    <a href="javascript:;" class="main-button c-main" @click="simpleAction">确认</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import SlideUpDown from 'vue-slide-up-down';

export default{
    components: {
        VueDatePicker,
        SlideUpDown,
    },
    data() {
        return {
            preDate1: null,
            preDate2: null,
            formatDate: 'yyyy-MM-dd', // 원하는 날짜 형식 설정
            select01: false,
            select02: false,
            select03: false,
            select04: false,

            // 예약 데이터
            params: {
                gender: 'M',
                countryGubun: 'K',
                rsvhour1: '',
                rsvmin1: '',
                rsvhour2: '',
                rsvmin2: ''
            }
        };
    },
    methods: {
        onFileChange(target, str){
            const file = target.files
            if(file.length > 0){
                this.params[str] = file[0]
                this.params[str + 'Name'] = file[0].name
            }
        },
        simpleAction(){
            if (!this.params.ptNo) {
                alert("请输入患者ID。");
                this.$refs.ptNo.focus();
                return false;
            }
            
            if (!this.params.firstName) {
                alert("请输入名字。");
                this.$refs.firstName.focus();
                return false;
            }
            
            if (!this.params.lastName) {
                alert("请输入姓氏。");
                this.$refs.lastName.focus();
                return false;
            }
            
            if (!this.params.birth) {
                alert("请输入出生日期。");
                this.$refs.birth.focus();
                return false;
            } else {
                var birthExp = /^(19[0-9][0-9]|20\d{2})-?(0[0-9]|1[0-2])-?(0[1-9]|[1-2][0-9]|3[0-1])$/;
                if(!birthExp.test(this.params.birth)) {
                    alert("出生日期输入不正确。");
                    this.$refs.birth.focus();
                    return false;
                }
            }
            
            if (!this.params.national) {
                alert("请输入您的国籍。");
                this.$refs.national.focus();
                return false;
            }
            
            if (!this.params.language) {
                alert("请输入您的语言。");
                this.$refs.language.focus();
                return false;
            }
            
            if (!this.params.address) {
                alert("请输入您的韩国地址。");
                this.$refs.address.focus();
                return false;
            }
            
            if (!this.params.hpNo) {
                alert("请输入您的电话号码。");
                this.$refs.hpNo.focus();
                return false;
            }
            
            if (!this.params.insuranceInfo) {
                alert("请输入您的保险信息。");
                this.$refs.insuranceInfo.focus();
                return false;
            }
            
            if (!this.params.symptoms) {
                alert("请输入您的症状。");
                this.$refs.symptoms.focus();
                return false;
            }
            
            if (!this.params.mediServiceReq) {
                alert("请输入您所需的服务。");
                this.$refs.mediServiceReq.focus();
                return false;
            }
            
            if (!this.preDate1) {
                alert("请输入您的 希望的第一次预订日期");
                return false;
            }
            
            if (!this.params.rsvhour1) {
                alert("请输入您的 希望的第一次预订日期");
                return false;
            }
            
            if (!this.params.rsvmin1) {
                alert("请输入您的 希望的第一次预订日期");
                return false;
            }
            
            if (!this.preDate2) {
                alert("请输入您的 希望的第二次预订日期");
                return false;
            }
            
            if (!this.params.rsvhour2) {
                alert("请输入您的 希望的第二次预订日期");
                return false;
            }
            
            if (!this.params.rsvmin2) {
                alert("请输入您的 希望的第二次预订日期");
                return false;
            }

            this.params.rsvDat1 = this.preDate1.toISOString().split('T')[0]
            this.params.rsvDat2 = this.preDate2.toISOString().split('T')[0]
            this.params.rsvhour1 = ('0' + (this.params.rsvhour1)).slice(-2);
            this.params.rsvhour2 = ('0' + (this.params.rsvhour2)).slice(-2);
            this.params.rsvmin1 = ('0' + (this.params.rsvmin1)).slice(-2);
            this.params.rsvmin2 = ('0' + (this.params.rsvmin2)).slice(-2);
            const urlParam = new URLSearchParams(this.params).toString();
            
            const formData = new FormData();

            // 기존 params의 내용 (파일 외의 다른 데이터) 추가
            Object.keys(this.params).forEach(key => {
                if (key !== 'uploadFile' && this.params[key] !== null) {
                    formData.append(key, this.params[key]);
                }
            });
            if (this.params.uploadFile) {
                formData.append('uploadFile', this.params.uploadFile);
            }

            const param = {langCd: this.$store.getters.getLang}
            this.axios.post(this.api.glb.reservation, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                params: param
            })
            .then(response => {
                const data =response.data
                if (data.result == "success") {
					alert("预订请求已完成。");
					// location.href = `/${this.$store.getters.getLang}/main`;
				} else {
					alert("预订请求失败。");
					return false;
				}
            }).catch(err => {
                alert('오류가 발생했습니다. 다시 시도해주시길 바랍니다.')
            });
        },
        cancelReservation(){
            if(confirm("Do you really want to cancel?")){
                location.href = `/${this.$store.getters.getLang}/main`;
            }
        },
        activeselect01() {
            this.select01 = !this.select01;
        },
        activeselect02() {
            this.select02 = !this.select02;
        },
        activeselect03() {
            this.select03 = !this.select03;
        },
        activeselect04() {
            this.select04 = !this.select04;
        },
    },
    mounted() {
        
    },
}
</script>
